import { WorkspaceModalSource, logEventV2 } from "react-migration/lib/util/logEventV2";
import { navigationStore } from "../store";
import { Project } from "@gql/sites-api/graphql";

export const setShowTopupModal = (v: boolean, initialAmount?: number) => {
  navigationStore.showTopupModal = v;

  if (v) {
    navigationStore.topupModalOptions = { initialAmount };
  } else {
    navigationStore.topupModalOptions = {};
  }
};

export const openNewProjectModal = (source: WorkspaceModalSource) => {
  logEventV2({ name: "New workspace", properties: { source } });
  navigationStore.newProjectModal = { source };
};

export const closeNewProjectModal = () => {
  navigationStore.newProjectModal = null;
};

export const setEditProjectModal = (
  v: Pick<Project, "id" | "title" | "developmentType" | "goal" | "image" | "imageUrl"> | null
) => {
  navigationStore.editProjectModal = v ? { project: v } : null;
};

export const setShowAddressModal = (v: boolean, props: typeof navigationStore.billingAddressModalProps) => {
  navigationStore.showBillingAddressModal = v;
  navigationStore.billingAddressModalProps = props;
};

export const setDebugModal = (v: boolean) => {
  navigationStore.showDebugModal = v;
};

export const setUserColorModal = (v: boolean) => {
  navigationStore.showUserColorModal = v;
};

export const setShowUpgradeModal = (v: boolean) => {
  navigationStore.showUpgradeModal = v;
};

export const setShowTrialEndingModal = (v: boolean) => {
  navigationStore.showTrialEndingModal = v;
};

export const setShowOverdueInvoiceModal = (v: boolean) => {
  navigationStore.showOverdueInvoiceModal = v;
};

export const setShowMultiDeviceBlockModal = (v: boolean) => {
  navigationStore.showMultiDeviceBlockModal = v;
};

export const setShowImpersonationBanner = (v: boolean) => {
  navigationStore.showImpersonationBanner = v;
};

export const setShowOverdueInvoiceBanner = (v: boolean) => {
  navigationStore.showOverdueInvoiceBanner = v;
};

type OpenAddOnsStoreModalParams = {
  path?: string;
  logClickSource: string;
};

export const openAddOnsStoreModal = ({ path = "/", logClickSource: clickSource }: OpenAddOnsStoreModalParams) => {
  logEventV2({
    name: "Store opened",
    properties: {
      clickSource,
    },
  });

  navigationStore.addOnsStoreModalPath = path;
};

export const closeAddOnsStoreModal = () => {
  navigationStore.addOnsStoreModalPath = undefined;
};
